import { render, staticRenderFns } from "./NavLanguageSelect.vue?vue&type=template&id=50af825c&scoped=true"
import script from "./NavLanguageSelect.vue?vue&type=script&lang=js"
export * from "./NavLanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./NavLanguageSelect.vue?vue&type=style&index=0&id=50af825c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af825c",
  null
  
)

export default component.exports